module.exports = __webpack_public_path__ + "static/media/NewCV_Design.9ce8d598.jpg";